import { combineReducers } from '@reduxjs/toolkit';
import promotionCampaignReducer from './promotion-campaign/promotion-campaign.slice';
import voucherReducer from './voucher/voucher.slice';

export const promotionReducer = combineReducers({
  promotionCampaign: promotionCampaignReducer,
  voucher: voucherReducer,
});
